module.exports = __webpack_public_path__ + "img/shape-22.221977ce.svg";